<canvas baseChart
    [data]="chartData()"
    [options]="chartOptions"
    type="line"
></canvas>